import React from 'react';
import { useToast } from '../../context/ToastContext';

const ToastContainer = () => {
  const { toasts, remove } = useToast();

  return (
    <div className="fixed top-4 right-4 z-50 flex flex-col gap-2">
      {toasts.map((t) => (
        <div key={t.id} className={`max-w-sm p-3 rounded shadow-lg text-sm ${t.type === 'error' ? 'bg-red-600 text-white' : 'bg-white text-gray-900'}`}>
          <div className="flex items-start gap-2">
            <div className="flex-1">{t.message}</div>
            <button className="text-xs text-gray-500" onClick={() => remove(t.id)}>Close</button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
